/**
 * Barcha enumlar `docs/05-backend-schema.md` dagi Prisma sxemasiga mos keladi.
 * TS `enum` emas, const object + union type ishlatiladi — `isolatedModules` bilan
 * to'liq mos va tree-shaking uchun xavfsiz.
 */

/** Interfeys tili — bot ikki tilda ishlaydi, WebApp faqat o'zbek tilida. */
export const Lang = {
  UZ: 'UZ',
  RU: 'RU',
} as const
export type Lang = (typeof Lang)[keyof typeof Lang]

/** Blogerning hamkorlik jarayonidagi bosqichi. */
export const BloggerStage = {
  NEW: 'NEW',
  ACTIVE: 'ACTIVE',
  REJECTED: 'REJECTED',
  BLOCKED: 'BLOCKED',
} as const
export type BloggerStage = (typeof BloggerStage)[keyof typeof BloggerStage]

/** Videoning ish jarayonidagi bosqichi (kanban ustuni). */
export const VideoStage = {
  MODERATION: 'MODERATION',
  POSTED: 'POSTED',
  CHECKING: 'CHECKING',
  PAID: 'PAID',
  REJECTED: 'REJECTED',
} as const
export type VideoStage = (typeof VideoStage)[keyof typeof VideoStage]

/** To'lov so'rovining holati. */
export const PayoutStatus = {
  REQUESTED: 'REQUESTED',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
} as const
export type PayoutStatus = (typeof PayoutStatus)[keyof typeof PayoutStatus]

/** To'lov qanday boshlangani — bloger so'rovi, jadval bo'yicha yoki admin qo'lda. */
export const PayoutType = {
  ON_REQUEST: 'ON_REQUEST',
  SCHEDULED: 'SCHEDULED',
  MANUAL: 'MANUAL',
} as const
export type PayoutType = (typeof PayoutType)[keyof typeof PayoutType]

/** Bloger yoki video rad etilish sababi. */
export const RejectReason = {
  LOW_FOLLOWERS: 'LOW_FOLLOWERS',
  PRIVATE_PROFILE: 'PRIVATE_PROFILE',
  IRRELEVANT_CONTENT: 'IRRELEVANT_CONTENT',
  FAKE_ACCOUNT: 'FAKE_ACCOUNT',
  LOW_QUALITY: 'LOW_QUALITY',
  BOOK_NOT_VISIBLE: 'BOOK_NOT_VISIBLE',
  NO_LINK: 'NO_LINK',
  LINK_DEAD: 'LINK_DEAD',
  OTHER: 'OTHER',
} as const
export type RejectReason = (typeof RejectReason)[keyof typeof RejectReason]

/** Blogerlar varonkasining kanban ustunlari tartibi. */
export const BLOGGER_STAGE_ORDER: readonly BloggerStage[] = [
  BloggerStage.NEW,
  BloggerStage.ACTIVE,
  BloggerStage.REJECTED,
  BloggerStage.BLOCKED,
]

/** Videolar varonkasining kanban ustunlari tartibi. */
export const VIDEO_STAGE_ORDER: readonly VideoStage[] = [
  VideoStage.MODERATION,
  VideoStage.POSTED,
  VideoStage.CHECKING,
  VideoStage.PAID,
  VideoStage.REJECTED,
]

/** Video bosqichlarining o'zbekcha nomlari (kanban ustun sarlavhalari). */
export const VIDEO_STAGE_LABELS: Record<VideoStage, string> = {
  MODERATION: 'Moderatsiya',
  POSTED: 'Joylandi',
  CHECKING: 'PM Tekshiruvda',
  PAID: "To'landi",
  REJECTED: 'Rad etildi',
}

/** Bloger bosqichlarining o'zbekcha nomlari. */
export const BLOGGER_STAGE_LABELS: Record<BloggerStage, string> = {
  NEW: 'Yangi',
  ACTIVE: 'Faol',
  REJECTED: 'Rad etilgan',
  BLOCKED: 'Bloklangan',
}

/** Rad etish sabablarining o'zbekcha nomlari. */
export const REJECT_REASON_LABELS: Record<RejectReason, string> = {
  LOW_FOLLOWERS: 'Obunachi kam',
  PRIVATE_PROFILE: 'Yopiq profil',
  IRRELEVANT_CONTENT: 'Mos kelmaydigan kontent',
  FAKE_ACCOUNT: 'Soxta akkaunt',
  LOW_QUALITY: 'Sifat past',
  BOOK_NOT_VISIBLE: "Kitob ko'rinmayapti",
  NO_LINK: 'Havola yuborilmadi',
  LINK_DEAD: "Havola ochilmadi / post o'chirilgan",
  OTHER: 'Boshqa',
}
